import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class EditSection extends Component {
  editSection = () => {
    const {
      actions,
      sectionUID,
      notificationSystem,
      editSectionProps,
      objectUID,
      afterEditSuccessAction
    } = this.props;
    let data = editSectionProps.entity.toJS();
    actions.updateSection(data, sectionUID).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        afterEditSuccessAction(objectUID);
      }
    });
    actions.setIsEditSectionModalVisible(false);
  };

  openEditSectionModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsEditSectionModalVisible(sectionUID);
  };

  closeEditSectionModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsEditSectionModalVisible(false);
  };

  render() {
    const { isEditModalVisible, sectionUID, editSectionProps } = this.props;

    return (
      <div className="col-xs-12">
        <button className="error" onClick={this.openEditSectionModal}>
          Edytuj sekcję
        </button>
        {isEditModalVisible === sectionUID && (
          <Modal
            closeModalAction={this.closeEditSectionModal}
            enterAction={this.editSection}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj pole</h3>
              <form className="col-xs-12">
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Nazwa pola</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputCustom {...editSectionProps} field={["name"]} />
                  </div>
                </div>
              </form>
              <div className="col-xs-12">
                <button className="info" onClick={this.editSection}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeEditSectionModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/template/editSection.react.js